var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDots = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 16,
    viewBox: "0 0 5 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 12.375C3.4665 12.375 4.25 13.1585 4.25 14.125C4.25 15.0915 3.4665 15.875 2.5 15.875C1.5335 15.875 0.75 15.0915 0.75 14.125C0.75 13.1585 1.5335 12.375 2.5 12.375ZM2.5 6.25C3.4665 6.25 4.25 7.0335 4.25 8C4.25 8.9665 3.4665 9.75 2.5 9.75C1.5335 9.75 0.75 8.9665 0.75 8C0.75 7.0335 1.5335 6.25 2.5 6.25ZM2.5 0.125C3.4665 0.125 4.25 0.908502 4.25 1.875C4.25 2.8415 3.4665 3.625 2.5 3.625C1.5335 3.625 0.75 2.8415 0.75 1.875C0.75 0.908502 1.5335 0.125 2.5 0.125Z",
    fill: "#1E293B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDots);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Dots.efa13352e1f862d305c7ba8296de0d69.svg";